import React, { useState } from "react";

import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";
import { create, getQuery, update } from "../../services/apiService";
import { useAuth } from "../../context/AuthContext";
import veriffLogo from "../../assets/icons/veriff_logo.svg";
import camera from "../../assets/images/camera.svg";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import OnboardingHeader from "../../layouts/OnboardingHeader";

const Verification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { userProfile } = useAuth();

  const navigate = useNavigate();

  const createVeriffSession = async (userId) => {
    try {
      // const response = await fetch("/api/v1/veriff/create-session", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ userId }),
      // });
      //const response = await create("/api/v1/veriff/create-session")
      const response = await getQuery("/api/v1/veriff/create-session", {
        userID: userId,
      });

      if (response.status == 200) {
        return response.data.data;
      }

      message.error("Failed to create veriff session");
    } catch (err) {
      return null;
    }
  };

  const updateKycStatus = async (userId) => {
    const data = {
      userId,
      status: "submitted",
    };
    try {
      const response = await create("/api/v1/user/update-kyc", data);
    } catch (error) {
      message.error("Could not update kyc status");
    }
  };

  const initiateVeriff = async () => {
    setIsLoading(true);

    const userId = userProfile._id;
    const sessionData = await createVeriffSession(userId);
    if (!sessionData || !sessionData.verification?.url) {
      setIsLoading(false);
      return;
    }

    const sessionUrl = sessionData.verification.url;

    createVeriffFrame({
      url: sessionUrl,
      onEvent: async (msg) => {
        switch (msg) {
          case MESSAGES.STARTED:
            break;
          case MESSAGES.CANCELED:
            break;
          case MESSAGES.FINISHED:
            // document.cookie =
            //   "veriff-verified=true; Path=/; Secure; SameSite=Lax";
            // window.location.href = "/veriff/successfully-verified";
            //await updateKycStatus(userProfile.id);
            navigate("/onboarding/ficadocuments");
            break;
          default:
            break;
        }
      },
      onReload: () => {
        window.location.reload();
      },
    });

    setIsLoading(false);
  };

  return (
    <>
      <OnboardingHeader title={"Verify ID"} />
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-white text-">
        {/* Top Logo */}
        <div className="absolute top-20">
          <img
            //src="/assets/icons/veriff_logo.svg"
            src={veriffLogo}
            alt="Veriff Logo"
            width={120}
            height={40}
          />
        </div>

        {/* Main Content */}
        <div className="z-10 mt-1 flex flex-col items-center space-y-6">
          <img
            //src="/assets/icons/tick.svg"
            src={camera}
            alt="Verified"
            width={100}
            height={100}
            className="mx-auto"
          />
          <h2 className="mt-6 text-2xl font-bold text-brand-primary">
            Are you ready for your close-up?
          </h2>
          <p className="text-sm text-center text-gray-600 max-w-md">
            Using Veriff, we’re going to verify your identity using a selfie and
            a photo of your ID.
          </p>
          <button
            onClick={initiateVeriff}
            disabled={isLoading}
            className={`mt-6 h-14 w-96 rounded-full font-semibold text-white transition-transform duration-200 shadow-lg ${
              isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 transform hover:scale-105"
            }`}
          >
            {isLoading ? "Processing..." : "I'm ready"}
          </button>
        </div>

        {/* Bottom Gradient Overlay */}
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-bg-light-gray-2 to-transparent pointer-events-none" />
      </div>
    </>
  );
};

export default Verification;
